<template>
  <div style="display: none">
    <!-- This component doesn't render anything visible -->
  </div>
</template>

<script>
import { onMounted } from "vue";
import analytics from "roaarrr-browser";

export default {
  name: "AnalyticsTracker",
  setup() {
    onMounted(() => {
      // Initialize Roaarrr analytics
      analytics.init(
        "eyJhbGciOiJIUzI1NiJ9.eyJwcm9qZWN0SWQiOiIyMmQyNTZhYy1hYTVhLTQ1MzQtYWNmNS03NjYxYzBmZWExN2MiLCJpYXQiOjE3NTU2OTUwNjgsImV4cCI6MTc4NzI1MjY2OH0.X-5U4bDBqV_mUosuG6OFC70MKJC9wj0rUT7JDK3Vp9c"
      );

      console.log("Roaarrr analytics initialized");
    });

    return {};
  },
};
</script>
